<template>
  <div class="progress-pic-uploader">
      <el-row :gutter="30" class="progress-pic">
      <el-col :span="12">
        <div class="checkin-pic-box">
          <div class="checkin-pic-container" style='background-image: url("https://fatguytofitguy.files.wordpress.com/2011/07/fatguy2_072111_copy.jpg");'>
            
            
          </div>
          <div class="checkin-pic-title">First Progress Picture</div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="checkin-pic-box">
          <div class="checkin-pic-container">
            <el-button type="default" @click="onUploadClicked">Upload Image</el-button>
            
          </div>
          <div class="checkin-pic-title">Next Progress Picture</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>


export default {
  name: 'progress-pic',
  
  data () {
    return {
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onUploadClicked:function openPicker() {
	    window.fsClient.pick({
	      fromSources:["local_file_system","imagesearch","facebook","instagram","dropbox"]
	    }).then(function(response) {
	      // declare this function to handle response
	      handleFilestack(response);
	    });
	  }
  }
}
</script>

<style>
  .checkin-pic-box {
    background-color: #FFF;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
  .checkin-pic-container {
    height: 230px;
    background-size: cover;
  }
  .checkin-pic-container button {
    margin-top: 100px;
  }
  .checkin-pic-title {
    width: 100%;
    height: 50px;
    background-color: #F1F1F1;
    line-height: 50px;
    color: #999;
  }
</style>
